import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { DatePicker } from './DatePicker';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { classes } from './DatePicker.visual.st.css';
import { EditorShell } from '../../test/visual/VisualAsync';

const VisualTestDatePicker = (props) => {
  const { width, ...rest } = props;

  return (
    <div style={{ width }}>
      <EditorShell>
        <DatePicker {...rest} />
      </EditorShell>
    </div>
  );
};

visualize('DatePicker', () => {
  story('simple', () => {
    snap(
      'default props',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/15')}
        onChange={() => {}}
      />,
    );
    snap(
      'responsiveness',
      <VisualTestDatePicker
        width="600px"
        value={new Date('2019/12/15')}
        onChange={() => {}}
      />,
    );
    snap(
      'FilterDate - Prior for today dates (includes today)',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/15')}
        filterDate={(date) => date <= new Date('2019/12/15')}
        onChange={() => {}}
      />,
    );
    snap(
      'FilterDate - future dates only (includes today)',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/15')}
        filterDate={(date) => date >= new Date('2019/12/15')}
        onChange={() => {}}
      />,
    );
    snap(
      'Months dropdown',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/15')}
        showMonthDropdown
        onChange={() => {}}
      />,
    );
    snap(
      'Years dropdown',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/15')}
        showYearDropdown
        onChange={() => {}}
      />,
    );
    snap(
      'Months and years dropdown',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/15')}
        showMonthDropdown
        showYearDropdown
        onChange={() => {}}
      />,
    );
    snap(
      'Date Indication',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/12')}
        onChange={() => {}}
        dateIndication={({ date }) =>
          date <= new Date('2019/12/15') ? (
            <div
              className="Indications"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                className="indication"
                style={{
                  borderRadius: '50%',
                  width: '3px',
                  height: '3px',
                  backgroundColor: '#7247FF',
                }}
              />
            </div>
          ) : null
        }
      />,
    );
    snap(
      'Adaptive to font change',
      <VisualTestDatePicker
        className={classes.dayFontSizeOverride}
        width="650px"
        value={new Date('2019/12/15')}
        onChange={() => {}}
      />,
    );
    snap(
      'Selected day border radius',
      <VisualTestDatePicker
        className={classes.selectedDayBorderRadius}
        width="280px"
        value={new Date('2019/12/15')}
        onChange={() => {}}
      />,
    );
    snap(
      'No outer padding',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/15')}
        onChange={() => {}}
        removeOuterPadding
      />,
    );
    snap(
      'Weeks Vertical Spacing',
      <VisualTestDatePicker
        className={classes.weeksVerticalSpacing}
        width="280px"
        value={new Date('2019/12/15')}
        onChange={() => {}}
      />,
    );
    snap(
      'Today as a prop',
      <VisualTestDatePicker
        width="280px"
        value={new Date('2019/12/15')}
        onChange={() => {}}
        today={new Date('2019/12/17')}
      />,
    );
    snap(
      'responsive rtl',
      <div dir="rtl">
        <TPAComponentsProvider value={{ rtl: true }}>
          <VisualTestDatePicker
            locale="he"
            firstDayOfWeek={0}
            width="600px"
            value={new Date('2019/12/15')}
            onChange={() => {}}
          />
        </TPAComponentsProvider>
      </div>,
    );
    snap('minHeight auto',
      <VisualTestDatePicker
        className={classes.minHeightAuto}
        width="280px"
        value={new Date('2019/12/15')}
        onChange={() => {}}
        today={new Date('2019/12/17')}
      />,
    );
  });

  const WstTest = ({
    variables,
  }: {
    variables: Record<`--wst-${string}`, string>;
  }) => (
    <div style={{ ...variables }}>
      <DatePicker
        onChange={() => {}}
        today={new Date('2019/12/14')}
        value={new Date('2019/12/15')}
      />
      <DatePicker
        showMonthDropdown
        showYearDropdown
        onChange={() => {}}
        today={new Date('2019/12/14')}
        value={new Date('2019/12/15')}
      />
    </div>
  );

  story('wst variables', () => {
    snap('primary background color', () => (
      <WstTest
        variables={{
          '--wst-primary-background-color-rgb': '0,255,0',
        }}
      />
    ));

    snap('paragraph 2', () => (
      <WstTest
        variables={{
          '--wst-paragraph-2-color-rgb': '0,255,0',
          '--wst-paragraph-2-font-family': 'Monospace',
          '--wst-paragraph-2-font-variant': 'small-caps',
          '--wst-paragraph-2-font-style': 'italic',
          '--wst-paragraph-2-font-size': '22px',
          '--wst-paragraph-2-font-weight': '900',
        }}
      />
    ));

    snap('links and actions', () => (
      <WstTest
        variables={{
          '--wst-links-and-actions-color-rgb': '0,255,0',
        }}
      />
    ));

    snap('disabled', () => (
      <WstTest
        variables={{
          '--wst-system-disabled-color-rgb': '0,255,0',
        }}
      />
    ));
  });
});
